<template>
  <icon-base
    icon-name="Google Scholar"
    :icon-color="iconColor"
    :width="width"
    :height="height">
    <g
     transform="matrix(1.3333331,0,0,1.3333331,16,6.5298861e-5)">
      <path
        d="M 27.64907,27.697688 C 18.43272,36.914088 9.21636,46.130388 0,55.346768 c 12.02986,0.22546 24.16187,-0.60269 36.11136,0.75407 -1.08098,17.79846 12.32533,35.61268 30.016,38.96006 4.60532,1.82742 11.28316,0.56872 15.12482,1.84959 -0.16595,6.379992 -1.30108,13.166602 2.41768,18.845312 -4.02161,4.27781 -15.05376,2.14568 -21.54166,5.08491 -14.9004,4.01061 -32.20854,12.16371 -35.72543,28.77473 -0.33906,8.89899 -2.36152,19.42304 4.61994,26.46758 9.68043,11.12332 24.72171,16.66692 39.3172,15.8354 14.49684,-0.27937 30.11398,0.74804 42.99508,-7.14649 9.3534,-4.72308 17.8075,-11.77461 21.7265,-21.76135 5.6344,-11.61454 4.9675,-26.71247 -3.5187,-36.84397 -7.3301,-10.18235 -19.1939,-16.02592 -26.4763,-26.246182 -0.051,-9.47672 10.7353,-14.24142 16.0566,-21.06409 10.8877,-10.05213 12.0183,-26.47685 7.5708,-39.84765 7.5346,-7.5188 15.0475,-15.0593 22.5381,-22.622 1.1849,6.345 -4.3011,10.8946 -3.2144,17.2932 -0.066,17.89671 -0.5164,35.82531 0.309,53.70485 2.6247,10.16381 17.0667,2.72581 12.8492,-6.46061 0.1999,-18.0484 0.076,-36.09874 0.1105,-54.14804 -4.8241,-2.9197 -4.3274,-8.6805 -4.1893,-13.62 -0.8805,-3.6794004 3.3885,-5.2499004 5.1947,-7.8290004 0.9098,-1.6998 7.5972,-5.81979997 3.157,-5.27849997 -36.7168,0 -73.4337,0 -110.15055,0 C 46.08179,9.2649876 36.86543,18.481388 27.64907,27.697688 Z m 58.81711,-3.4352 c 13.03761,6.5246 18.50941,21.915 20.42061,35.48895 1.2961,9.118 -0.9956,20.18986 -10.534,23.91469 -10.61485,6.2507 -23.7622,-0.90152 -29.00007,-10.89206 -6.26729,-11.97252 -10.67035,-27.39788 -3.9089,-40.07248 4.34258,-7.6854 14.68203,-12.383 23.02236,-8.4391 z M 97.02309,128.40735 c 8.282,6.07206 18.0567,12.14829 21.8718,22.15198 4.3458,12.76132 -6.2201,26.91527 -19.2758,28.21855 -16.43749,3.198 -36.60529,1.262 -47.40005,-13.09607 -6.58067,-9.75227 -4.09572,-24.96762 6.68575,-30.75597 10.58518,-6.46849 23.6486,-7.84298 35.8137,-7.18845 l 1.3209,0.28331 z"/>
    </g>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase'

export default {
  name: 'icon-googlescholar',

  components: {
    'icon-base': IconBase
  },

  props: {
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    width: {
      type: [Number, String],
      default: 256
    },
    height: {
      type: [Number, String],
      default: 256
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/typography/IconGoogleScholar.vue